
const INITIAL_STATE = {
  // 企业
  organization: {},
};

const organization = {
  state: {
    ...INITIAL_STATE,
  },
  actions: {
  },
  reducers: {
    switchOrganization(prevState, payload) {
      const { organization, } = payload;
      return {
        ...prevState,
        organization: { ...organization },
      };
    },
  }
}

export default organization;
